import photoOne from "../Assets/WinePhotos/photoOne.png";
import photoTwo from "../Assets/WinePhotos/photoTwo.png";
import photoFour from "../Assets/WinePhotos/photoFour.png";
import photoFive from "../Assets/WinePhotos/photoFive.png";
import photoSix from "../Assets/WinePhotos/photoSix.png";
import photoSeven from "../Assets/WinePhotos/photoSeven.png";
import photoEight from "../Assets/WinePhotos/photoEight.png";
import photoNine from "../Assets/WinePhotos/photoNine.png";
import photoTen from "../Assets/WinePhotos/photoTen.png";
import photoEleven from "../Assets/WinePhotos/photoEleven.png";
import photoTwelve from "../Assets/WinePhotos/photoTwelve.png";
import photoThirteen from "../Assets/WinePhotos/photoThirteen.png";
import photoFourteen from "../Assets/WinePhotos/photoFourteen.png";
import photoFifteen from "../Assets/WinePhotos/photoFifteen.png";
import photoSeventeen from "../Assets/WinePhotos/photoSeventeen.png";
import photoEighteen from "../Assets/WinePhotos/photoEighteen.png";
import photoNineteen from "../Assets/WinePhotos/photoNineteen.png";
import photoTwenty from "../Assets/WinePhotos/photoTwenty.png";
import photoTwentyOne from "../Assets/WinePhotos/photoTwentyOne.png";
import photoTwentyTwo from "../Assets/WinePhotos/photoTwentyTwo.png";


const photoGallery = [
  // Gallery One
  {
    name: "Image of ...",
    imageSource: photoEight,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 4,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoTen,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 4,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoFifteen,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 4,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoThirteen,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 6,
    },
  },

  // Gallery Two
  {
    name: "Image of ...",
    imageSource: photoSeventeen,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 6,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoSeven,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 4,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoFourteen,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 4,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoEleven,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 4,
    },
  },

  // Gallery Three
  {
    name: "Image of ...",
    imageSource: photoNine,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 4,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoTwenty,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 8,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoEighteen,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 6,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoTwelve,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 3,
    },
  },

  // Gallery Four

  {
    name: "Image of ...",
    imageSource: photoFour,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 3,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoFive,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 3,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoSix,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 3,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoNineteen,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 6,
    },
  },

  // Gallery Five
  {
    name: "Image of ...",
    imageSource: photoTwo,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 8,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoTwentyTwo,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 4,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoOne,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 4,
    },
  },
  {
    name: "Image of ...",
    imageSource: photoTwentyOne,
    gridBreakPoints: {
      sx: 6,
      sm: 6,
      md: 0,
      lg: 4,
    },
  },
];

export default photoGallery;
